import { Select, SelectProps } from 'antd';
import useSystem from 'hooks/business/system/useSystem';
import React from 'react';
import languageOptions from './languageOptions';

export interface LanguageSelectProps extends SelectProps<General.SystemLanguage> {}

const LanguageSelect = (props: LanguageSelectProps) => {
  const {
    systemSetting: { language },
    handleLanguageSettingChange,
  } = useSystem();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      options={languageOptions}
      value={language}
      onChange={handleLanguageSettingChange}
      bordered={false}
      {...props}
    />
  );
};
export default React.memo(LanguageSelect);
